var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"21.06 2.15 18.91 0 10.53 8.38 2.15 0 0 2.15 8.38 10.53 0 18.91 2.15 21.06 10.53 12.68 18.91 21.06 21.06 18.91 12.68 10.53 21.06 2.15"}));
}

Close.defaultProps = {"data-name":"Capa 1","viewBox":"0 0 21.06 21.06"};

module.exports = Close;

Close.default = Close;
